import { SnackbarContent } from "notistack";
import { makeStyles } from "@mui/styles";
import * as React from "react";
import { cn } from "../../../shared/utils/cn";
import { useState, useEffect } from "react";
import { LinearProgress } from "@mui/material";
const useStyles = makeStyles(() => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#313131",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    fontSize: "0.875rem",
    lineHeight: 1.43,
    letterSpacing: "0.01071em",
    color: "#fff",
    alignItems: "center",
    padding: "6px 16px",
    borderRadius: "4px",
    boxShadow:
      "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)",
  },

  message: {
    display: "flex",
    alignItems: "center",
    padding: "8px 0",
  },
  progress: {
    position: "absolute",
    top: "5px",
    bottom: "0",
    right: "0",
    left: "0",
    height: "7px",
  },
}));

const WithTimer = React.forwardRef((props, ref) => {
  const { message, messageProps, className, ...other } = props;
  const { className: messageClassName } = messageProps || {};
  const { autoHideDuration } = other;
  const classes = useStyles();
  const [timeLeft, setTimeLeft] = useState(autoHideDuration);

  useEffect(() => {
    let timer = setInterval(() => {
      setTimeLeft((time) => {
        if (time === 0) {
          clearInterval(timer);
          return 0;
        } else return time - 4;
      });
    }, 1);
  }, []);

  return (
    <SnackbarContent
      ref={ref}
      role="alert"
      className={cn(classes.root, className)}
      {...other}
    >
      <div className={cn(classes.message, messageClassName)}>{message}</div>
      {/* {(timeLeft / autoHideDuration) * 100} */}

      <LinearProgress
        className={cn(classes.progress)}
        sx={{
          width: "100%",
        }}
        variant="determinate"
        value={(timeLeft / autoHideDuration) * 100}
      />
    </SnackbarContent>
  );
});

export default WithTimer;
